/* eslint-disable no-underscore-dangle */
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Switch } from 'antd';
import { featuresValidationSchema } from './feature.schema';
import { BasicFormWrapper } from '../../styled';
import FormInput from '../../../components/input/input';
import { DEFAULT_LANG, LANGUAGE_BY_DOMAIN } from '../../../utils/constants';
import DivBreak from '../../../components/divBreak/DivBreak';
import { Button } from '../../../components/buttons/buttons';
import { addNewFeatures, editFeatures, getAllFeaturesCategory } from '../../../redux/featuresCategory/actionCreator';

const FeatureForm = props => {
  const { formData, onCancel, parent } = props;
  const [isMultiLangFlag, setIsMultiLangFlag] = useState(false);
  const dispatch = useDispatch();
  const categoryLoading = useSelector(state => state.featuresCategory.loading);

  useEffect(() => {
    setIsMultiLangFlag(formData?.isMultiLang.includes('true'));
  }, [formData]);

  async function handleFormSubmit(requestData, resetForm) {
    try {
      const transformedCategory = [];
      LANGUAGE_BY_DOMAIN.forEach(langItem => {
        if (requestData.isMultiLang === 'true' || langItem[1] === DEFAULT_LANG.value) {
          transformedCategory.push({
            lang: langItem[1],
            feature: requestData[`feature${langItem[1]}`],
          });
        }
      });

      const formValue = {
        details: transformedCategory,
        category: parent,
      };

      // eslint-disable-next-line no-underscore-dangle
      const res = requestData?._id ? await editFeatures(requestData?._id, formValue) : await addNewFeatures(formValue);

      if (res?.status) {
        getAllFeaturesCategory(dispatch);
        resetForm();
        onCancel();
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    }
  }

  return (
    <Formik
      initialValues={formData}
      validationSchema={featuresValidationSchema(isMultiLangFlag)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        setSubmitting(false);
        // eslint-disable-next-line no-use-before-define
        handleFormSubmit(values, resetForm);
      }}
      enableReinitialize
    >
      {({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
          <Form>
            <BasicFormWrapper>
              <div className="add-product-block">
                <Row gutter={[16, 16]}>
                  {/* language switcher */}
                  <Col xs={24}>
                    <h4>Translate</h4>
                    <Switch
                      checked={values.isMultiLang === 'true'}
                      onChange={checked => {
                        setFieldValue('isMultiLang', String(checked));
                        setIsMultiLangFlag(checked);
                      }}
                    />
                  </Col>
                  {/* Feature default  */}
                  <Col xs={24}>
                    <FormInput
                      name={`feature${DEFAULT_LANG.value}`}
                      label={`Title (${DEFAULT_LANG.label})`}
                      value={values[`feature${DEFAULT_LANG.value}`]}
                      handleChange={handleChange}
                      placeholder="Feature name"
                      errors={errors}
                      touched={touched}
                    />
                  </Col>
                  {/* Feature dynamic  */}
                  {values.isMultiLang === 'true' &&
                    LANGUAGE_BY_DOMAIN.filter(item => DEFAULT_LANG.value !== item[1]).map(([label, value], index) => {
                      return (
                        <Col xs={24} key={index}>
                          <FormInput
                            name={`feature${value}`}
                            label={`Title (${label})`}
                            value={values[`feature${value}`]}
                            handleChange={handleChange}
                            placeholder="Feature name"
                            errors={errors}
                            touched={touched}
                          />
                        </Col>
                      );
                    })}
                </Row>
              </div>

              <DivBreak />

              <Row justify="end" align="middle">
                <Col>
                  <Button
                    style={{
                      backgroundColor: '#155BDC',
                      color: '#fff',
                      marginRight: 5,
                      height: '40px',
                      fontWeight: '500',
                    }}
                    htmlType="submit"
                    loading={categoryLoading}
                  >
                    {values?._id ? 'Edit Feature' : 'Add Feature'}
                  </Button>
                  <Button size="default" type="white" key="back" outlined onClick={onCancel}>
                    Cancel
                  </Button>
                </Col>
              </Row>
            </BasicFormWrapper>
          </Form>
        );
      }}
    </Formik>
  );
};

FeatureForm.propTypes = {
  formData: PropTypes.object,
  onCancel: PropTypes.func,
  parent: PropTypes.string,
};
export default FeatureForm;
